"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var formik_1 = require("formik");
var FieldWrapper_1 = __importDefault(require("../FieldWrapper"));
var TextField = function (_a) {
    var question = _a.question, fieldName = _a.fieldName, questionNumber = _a.questionNumber, _b = _a.autoComplete, autoComplete = _b === void 0 ? false : _b, _c = _a.multiLine, multiLine = _c === void 0 ? false : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d;
    return (react_1.default.createElement(FieldWrapper_1.default, { questionNumber: questionNumber, instructions: question.instructions, fieldName: fieldName },
        react_1.default.createElement(formik_1.Field, { autoComplete: autoComplete ? 'on' : 'off', className: 'form-control text-dark', placeholder: question.placeHolder, name: fieldName, component: multiLine ? "textarea" : undefined, disabled: disabled, id: question.uniqueID + "-input" })));
};
exports.default = TextField;
